const MAIL_ACTION = 'mail'
const CREATE_ACTION = 'create'
const DESTROY_ACTION = 'destroy'

const HELPER_ENTITIES = {
  companySupplier: 'companySuppliers',
}

const FEMININE_ENTITIES = ['Task', 'task']

export default {
  CREATE_ACTION,
  DESTROY_ACTION,
  FEMININE_ENTITIES,
  HELPER_ENTITIES,
  MAIL_ACTION,
}
